/**
 * Diagnostic catalogue: titles, explanations and value hints per code, generated from the engine's
 * packages/schema/diagnostic_codes.json into codes.generated.json (`pnpm gen:types`).
 * The engine's messages stay the truth; the catalogue only labels and explains. Unknown codes fall
 * back to the code itself.
 */
import generated from './codes.generated.json';

export type CatalogLang = 'fr' | 'en';

export interface CatalogEntry {
  category: string;
  severity_default: 'error' | 'warning' | 'info';
  title_fr: string;
  title_en: string;
  explanation_fr: string | null;
  explanation_en: string | null;
  /** What `expected` / `actual` mean for this code, when it uses them. */
  values_fr: string | null;
  values_en: string | null;
}

export interface Catalog {
  catalog_version: string;
  codes: Record<string, CatalogEntry>;
}

export const ENGINE_CATALOG = generated as unknown as Catalog;

/** Codes emitted by the playground itself (never by the engine). */
const APP_CODES: Record<string, CatalogEntry> = {
  MOCK_ENGINE: {
    category: 'engine',
    severity_default: 'info',
    title_fr: 'Moteur de démonstration',
    title_en: 'Demo engine',
    explanation_fr: 'Résultats pré-enregistrés : ce texte n’est pas réellement vérifié.',
    explanation_en: 'Pre-recorded results: this text is not actually checked.',
    values_fr: null,
    values_en: null,
  },
};

export function catalogEntry(code: string): CatalogEntry | undefined {
  return ENGINE_CATALOG.codes[code] ?? APP_CODES[code];
}

export function diagnosticTitle(code: string, lang: CatalogLang): string {
  const entry = catalogEntry(code);
  return (lang === 'fr' ? entry?.title_fr : entry?.title_en) || code;
}

export function diagnosticExplanation(code: string, lang: CatalogLang): string | null {
  const entry = catalogEntry(code);
  return (lang === 'fr' ? entry?.explanation_fr : entry?.explanation_en) || null;
}

export function diagnosticValuesHint(code: string, lang: CatalogLang): string | null {
  const entry = catalogEntry(code);
  return (lang === 'fr' ? entry?.values_fr : entry?.values_en) || null;
}
